@if (isTokenLoading$ | async) {
  <figure class="sh-app-loading-msg">
    <img src="assets/images/logo/digihaven-plain.svg" alt="Digihaven" class="sh-app-loading-msg__img" width="52" />
    <figcaption>{{ 'ui.loading' | translate }}</figcaption>
  </figure>
}

<router-outlet></router-outlet>

<sh-toast-container [toasts]="toasts$ | async" (closeToast)="deleteToastById($event)"></sh-toast-container>
